<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M19.6 11.1q.8.9 0 1.8L13 19.6q-.9.8-1.8 0L4.4 13a1.3 1.3 0 1 1 1.8-1.8L12 17l5.8-5.9q.9-.7 1.8 0"
    />
    <path
      d="M19.6 4.4q.8.9 0 1.8L13 12.9q-.9.7-1.8 0L4.4 6.2a1.3 1.3 0 1 1 1.8-1.8l5.8 5.8 5.8-5.8q.9-.7 1.8 0"
    />
  </svg>
</template>
